import { forwardRef, useState } from 'react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { FileDown, Highlighter, MoreVertical } from 'lucide-react';

import { Button } from '@/components/Button/Button';

import styles from './ChapterActionsMenu.module.css';

interface ChapterActionsMenuProps {
  annotationAvailable: boolean;
  annotationsOpen: boolean;
  onExportPdf(): void;
  onToggleAnnotations(): void;
}

export const ChapterActionsMenu = forwardRef<
  HTMLButtonElement,
  ChapterActionsMenuProps
>(function ChapterActionsMenu(
  {
    annotationAvailable,
    annotationsOpen,
    onExportPdf,
    onToggleAnnotations,
  },
  ref,
) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <DropdownMenu.Root modal={false} onOpenChange={setIsOpen} open={isOpen}>
      <DropdownMenu.Trigger asChild>
        <Button
          aria-label="Open chapter actions"
          className={styles.trigger}
          iconOnly
          ref={ref}
          size="large"
          variant="secondary"
        >
          <MoreVertical aria-hidden="true" size={22} />
        </Button>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="end"
          className={styles.menuContent}
          sideOffset={8}
        >
          {annotationAvailable ? (
            <DropdownMenu.Item
              className={styles.menuItem}
              onSelect={() => {
                setIsOpen(false);
                onToggleAnnotations();
              }}
            >
              <Highlighter aria-hidden="true" size={16} />
              <span>
                {annotationsOpen ? 'Hide annotations' : 'Show annotations'}
              </span>
            </DropdownMenu.Item>
          ) : null}
          <DropdownMenu.Item
            className={styles.menuItem}
            onSelect={() => {
              setIsOpen(false);
              onExportPdf();
            }}
          >
            <FileDown aria-hidden="true" size={16} />
            <span>Export to PDF</span>
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
});
